export default {
  meEndpoint: '/auth/me',
  loginEndpoint: '/jwt/login',
  registerEndpoint: '/jwt/register',
  onTokenExpiration: 'refreshToken', // logout | refreshToken
  storageTokenKeyName: 'Token',
}